module.exports = __webpack_public_path__ + "static/media/email-link-clicked.53d55bac.svg";